/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_CustomerInputs */

const en_orders_customer = /** @type {(inputs: Orders_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer`)
};

const es_orders_customer = /** @type {(inputs: Orders_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente`)
};

/**
* | output |
* | --- |
* | "Customer" |
*
* @param {Orders_CustomerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_customer = /** @type {((inputs?: Orders_CustomerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CustomerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_customer(inputs)
	return es_orders_customer(inputs)
});